import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '@airclou/ui';
import type { CompanyGroup } from '@/api/groups';

interface DeleteGroupModalProps {
  group: CompanyGroup;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function DeleteGroupModal({ group, isOpen, onClose, onConfirm, isLoading }: DeleteGroupModalProps) {
  const { t } = useTranslation('dashboard');

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Delete "${group.name}"?`}
      variant="danger"
      confirmText={t('groups.deleteGroup')}
      onConfirm={onConfirm}
      isLoading={isLoading}
      description={
        <div className="space-y-3">
          <p>{t('groups.deleteGroupConfirmWill')}</p>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>{t('groups.deleteGroupRemoveMembers', { count: group.member_count, label: group.member_count === 1 ? 'member' : 'members' })}</li>
            <li>{t('groups.deleteGroupRevokeAccess', { count: group.workspace_count, label: group.workspace_count === 1 ? 'workspace' : 'workspaces' })}</li>
          </ul>
          <p className="font-medium">{t('common.actionCannotBeUndone')}</p>
        </div>
      }
    />
  );
}
